import { api, authentication, dataLayer } from '@dpgradio/creative'
import { defineStore } from 'pinia'
import { FORM_ID } from '../constants'
import { intervalToDuration } from 'date-fns'
import { LOCAL_STORAGE_KEY, ENABLE_SECONDS, DATES, QUESTION_DATE_ID, QUESTION_DURATION_STRING_ID } from '../constants'
const pad = (n) => (n < 10 ? `0${n}` : n)

export const useFormStore = defineStore('form', {
  state: () => ({
    subscribed: localStorage.getItem(LOCAL_STORAGE_KEY) ?? false,
    selectedDate: null,
    answers: {},
    isSigningUp: false,
  }),
  getters: {
    startDate() {
      const [d, start] = DATES[0]
      const date = new Date(d)
      date.setHours(start)
      return date
    },
    notCatchedDurationString() {
      if (ENABLE_SECONDS) {
        return '100:00:00'
      } else {
        return '100:00'
      }
    },
    durationParts() {
      const duration = intervalToDuration({
        start: this.startDate,
        end: this.selectedDate,
      })
      const hours = (duration.days || 0) * 24 + (duration.hours || 0)
      const minutes = duration.minutes || 0
      const seconds = duration.seconds || 0

      return [hours, minutes, seconds]
    },
    durationString() {
      if (!this.selectedDate) return this.notCatchedDurationString

      const [hours, minutes, seconds] = this.durationParts
      const parts = [
        `${hours} uur`,
        `${minutes} ${minutes == 1 ? 'minuut' : 'minuten'}`,
        `${seconds} ${seconds == 1 ? 'seconde' : 'seconden'}`,
      ]
      const formatter = new Intl.ListFormat('nl', { style: 'long', type: 'conjunction' })
      if (!ENABLE_SECONDS) {
        parts.pop()
      }
      return formatter.format(parts)
    },
    duration() {
      if (!this.selectedDate) return this.notCatchedDurationString

      const [hours, minutes, seconds] = this.durationParts
      if (ENABLE_SECONDS) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
      } else {
        return `${pad(hours)}:${pad(minutes)}`
      }
    },
  },
  actions: {
    setSelectedDate(date) {
      this.selectedDate = date
      this.answers = {
        ...this.answers,
        [QUESTION_DATE_ID]: date,
        [QUESTION_DURATION_STRING_ID]: this.durationString,
      }
    },
    setAnswers(answers) {
      this.answers = {
        ...this.answers,
        ...answers,
      }
    },
    async signUp() {
      if (this.isSigningUp) {
        return
      }

      this.isSigningUp = true
      const answerAttributes = Object.assign(
        {},
        Object.entries(this.answers)
          .filter(([, answer]) => {
            return answer
          })
          .map(([id, answer]) => ({
            webform_question_id: id,
            content: answer,
          }))
      )

      try {
        const response = await api.request().post(`https://qmusic.nl/webform/forms/${FORM_ID}/submissions`, {
          webform_submission: {
            answers_attributes: answerAttributes,
          },
          token: authentication.radioToken,
        })

        const { errors } = response
        if (errors['gigya_uid']) {
          throw new Error('Oeps! Je hebt al eens deelgenomen')
        }

        dataLayer.pushEvent('submit_success', {
          type: 'form',
          form_id: FORM_ID,
        })
        localStorage.setItem(LOCAL_STORAGE_KEY, this.duration)
        this.subscribed = true
      } catch (e) {
        dataLayer.pushEvent('submit_failure', {
          type: 'form',
          form_id: FORM_ID,
          error: e,
        })
        throw e
      } finally {
        this.isSigningUp = false
      }
    },
  },
})
